"use client";

import styles from "./BlocksRenderer.module.css";
import CardsBlock from "@/components/bumble/Cards";
import CarouselBlock from "@/components/bumble/Carousel";
import HeroBlock from "@/components/bumble/Hero";
import CeoSectionBlock from "@/components/custom/CeoSection";
import GreyCardsBlock from "@/components/custom/GreyCards";
import LocationsBlock from "@/components/custom/Locations";
import TabbedSectionBlock from "@/components/custom/TabbedSection";
import TextWithSubheadingBlock from "@/components/custom/TextWithSubheading";
import YellowCtaBlock from "@/components/custom/YellowCta";
export default function BlocksRenderer({
  blocks = []
}: {
  blocks: any[];
}) {
  const blocksToRender = blocks.map((block, index) => {
    switch (block._modelApiKey) {
      case "cards_with_yellow_block":
        return <CardsBlock key={block.id ?? index} data={block} />;
      case "carousel":
        return <CarouselBlock key={block.id ?? index} data={block} />;
      case "ceo_section":
        return <CeoSectionBlock key={block.id ?? index} data={block} />;
      case "grey_card_grid":
        return <GreyCardsBlock key={block.id ?? index} data={block} />;
      case "hero":
        return <HeroBlock key={block.id ?? index} data={block} />;
      case "location":
        return <LocationsBlock key={block.id ?? index} data={block} />;
      case "tabbed_section":
        return <TabbedSectionBlock key={block.id ?? index} data={block} />;
      case "text_with_subheading":
        return <TextWithSubheadingBlock key={block.id ?? index} subheading={block.subheading ?? undefined} text={block.text ?? undefined} />;
      case "yellow_cta":
        return <YellowCtaBlock key={block.id ?? index} href={block.cta.link} />;
      default:
        return null;
    }
  });
  return <div className={styles.wrapper}>{blocksToRender}</div>;
}